import { render, staticRenderFns } from "./ProfileGroupBusiness.vue?vue&type=template&id=657fcaf6&scoped=true"
import script from "./ProfileGroupBusiness.vue?vue&type=script&lang=js"
export * from "./ProfileGroupBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657fcaf6",
  null
  
)

export default component.exports